var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productTableHeader"},[_c('v-data-table',{staticClass:"rounded-lg",attrs:{"headers":_vm.tableHeaders,"items":_vm.items,"item-key":_vm.itemKey,"hide-default-header":false,"hide-default-footer":"","items-per-page":-1,"no-data-text":_vm.$t('common.common_no-history')},scopedSlots:_vm._u([{key:"item.productName",fn:function(ref){
var item = ref.item;
return [_vm._t("productName",null,{"item":item})]}},{key:"item.quantityDate",fn:function(ref){
var item = ref.item;
return [_vm._t("quantityDate",null,{"item":item})]}},{key:"item.stockQuantity",fn:function(ref){
var item = ref.item;
return [_vm._t("stockQuantity",null,{"item":item})]}},{key:"item.productCapacity",fn:function(ref){
var item = ref.item;
return [_vm._t("productCapacity",null,{"item":item})]}}],null,true)}),_vm._t("expandFooter")],2)}
var staticRenderFns = []

export { render, staticRenderFns }